<template lang="pug">
  section.hero
    .hero-body
      .container
        WtTitle(h1) FORBIDDEN
</template>

<script>
import WtTitle from "@@/WtTitle/WtTitle";

export default {
  name: "Forbidden403",

  components: { WtTitle }
};
</script>

<style lang="sass"></style>
